<script setup lang="ts">
import { HypertensionCondition, PersonData, PrescribedConditionTypes } from "@/entities/conditions";
import MedicalFormBuilder from "@/components/medicalConditionForms/MedicalFormBuilder.vue";
import BloodPressureReadings from "./BloodPressureReadings.vue";
import { parseSchema } from "@/components/medicalConditionForms/schema";
import { useMedicalForm } from "../useMedicalForm";

import hypertension from "./hypertension.json";

export interface Props {
    condition: HypertensionCondition,
    personDetails: PersonData
}

const props = defineProps<Props>();

const emit = defineEmits<{
        (on:"update:condition", value: HypertensionCondition): void
    }>();

const { onConditionUpdate, state } = useMedicalForm<
    {type: PrescribedConditionTypes.Hypertension} & HypertensionCondition
>({
    ...props.condition,
    type: PrescribedConditionTypes.Hypertension,
    medications: props.condition.medications || [],
    pressureReadings: props.condition.pressureReadings || [],
    hypertensionDiagnosisDate: props.condition.hypertensionDiagnosisDate || "",

}, emit);
</script>

<template>
    <MedicalFormBuilder
        :schema="parseSchema(hypertension)"
        :initial-form="state.condition"
        :diagnosis-date="state.condition.hypertensionDiagnosisDate"
        :person-details="props.personDetails"
        @update:form="onConditionUpdate"
    >
        <template #pressureReadings>
            <BloodPressureReadings
                v-model="state.condition.pressureReadings"
                :diagnosis-date="state.condition.hypertensionDiagnosisDate"
            />
        </template>
    </MedicalFormBuilder>
</template>

<style>

</style>
